import { render, staticRenderFns } from "./DryingHistory.vue?vue&type=template&id=1f8645d8&scoped=true&"
import script from "./DryingHistory.vue?vue&type=script&lang=ts&"
export * from "./DryingHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8645d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VHover,VProgressCircular})
